/* eslint-disable */

import {API, PerformJSONRPCRequest} from '../../api/jsonrpc';
import Report from "./Report";

export interface FindAllRequest {
    dashboardId: string
}

export interface FindAllResponse {
    reports: Report[];
}

export interface FindOneRequest {
    id: string
}

export interface FindOneResponse {
    report: Report;
}

export interface UpdateOneRequest {
    report: Report;
}

export interface UpdateOneResponse {
    id: string
}

export interface UpdateManyRequest {
    report: Report[];
}

export interface UpdateManyResponse {
    ids: string[]
}

export interface CreateOneRequest {
    name: string;
    dashboardId: string;
    variableData: any;

    cronString: string;
    emailList: string;
}

export interface CreateOneResponse {
    id: string
}

export interface DeleteOneRequest {
    id: string
}

export interface DeleteOneResponse {
    deleted: boolean;
}

const Store = {
    serviceProvider: 'Report-Store',
    async FindAll(request: FindAllRequest): Promise<FindAllResponse> {
        const response = await PerformJSONRPCRequest({
            api: API.Authorised,
            method: `${Store.serviceProvider}.FindAll`,
            request: [{
                'dashboardId': request.dashboardId
            }]
        });
        return {
            reports: response.reports.map((mem) => (new Report(mem))),
        };
    },
    async FindOne(request: FindOneRequest): Promise<FindOneResponse> {
        const response = await PerformJSONRPCRequest({
            api: API.Authorised,
            method: `${Store.serviceProvider}.FindOne`,
            request: [{
                'id': request.id
            }]
        });
        return {
            report: response.report
        };
    },
    async UpdateOne(request: UpdateOneRequest): Promise<UpdateOneResponse> {
        const response = await PerformJSONRPCRequest({
            api: API.Authorised,
            method: `${Store.serviceProvider}.UpdateOne`,
            request: [{
                'report': request.report
            }]
        });
        return {
            id: response.id
        };
    },
    async UpdateMany(request: UpdateManyRequest): Promise<UpdateManyResponse> {
        const response = await PerformJSONRPCRequest({
            api: API.Authorised,
            method: `${Store.serviceProvider}.UpdateMany`,
            request: [{
                'widgets': request.report
            }]
        });
        return {
            ids: response.ids
        };
    },
    async CreateOne(request: CreateOneRequest): Promise<CreateOneResponse> {
        const response = await PerformJSONRPCRequest({
            api: API.Authorised,
            method: `${Store.serviceProvider}.CreateOne`,
            request: [{
                'report': {
                    name: request.name,
                    dashboardId: request.dashboardId,
                    variableData: request.variableData,

                    cronString: request.cronString,
                    emailList: request.emailList
                }
            }]
        });
        return {
            id: response.id
        };
    },
    async DeleteOne(request: DeleteOneRequest): Promise<DeleteOneResponse> {
        const response = await PerformJSONRPCRequest({
            api: API.Authorised,
            method: `${Store.serviceProvider}.DeleteOne`,
            request: [{
                'id': request.id
            }]
        });
        return {
            deleted: response.deleted
        };
    },
};

export default Store;
